import z from "zod";

const CourseInfoSchema = z.object({
  staffId: z.number().gt(0),
  staffFirstName: z.string(),
  staffLastName: z.string(),
  period: z.string(),
  courseTitle: z.string(),
  scheduleDay: z.string(),
  section: z.string(),
  courseId: z.string(),
  schoolId: z.number().gt(0),
})

export class CourseInfo {
  constructor(data: z.infer<typeof CourseInfoSchema>) {
    Object.assign(this, data)
  }

  public readonly staffId!: number
  public readonly staffFirstName!: string
  public readonly staffLastName!: string
  public readonly period!: string
  public readonly courseTitle!: string
  public readonly scheduleDay!: string
  public readonly section!: string
  public readonly courseId!: string
  public readonly schoolId!: number

  public compositeKey(): string {
    return `${this.schoolId}:${this.period}:${this.section}:${this.courseTitle}`
  }
}

const StudentSchema = z.object({
  districtId: z.number().gt(0),
  schoolId: z.number().gt(0),
  districtName: z.string(),
  schoolName: z.string(),
  studentId: z.number().gt(0),
  nameFirst: z.string(),
  nameLast: z.string(),
  email: z.string().optional(),
  grade: z.string().optional(),
  studentCode: z.string().optional(),
  phoneCell: z.string().optional(),
  courses: z.array(CourseInfoSchema)
})

export class Student {
  constructor(data: z.infer<typeof StudentSchema>) {
    Object.assign(this, data)
    this.courses = data.courses.map(v => new CourseInfo(v))
  }

  public readonly districtId!: number
  public readonly schoolId!: number
  public readonly districtName!: string
  public readonly schoolName!: string
  public readonly studentId!: number
  public readonly nameFirst!: string
  public readonly nameLast!: string
  public readonly email?: string
  public readonly grade?: string
  public readonly studentCode?: string
  public readonly phoneCell?: string
  public readonly courses: CourseInfo[]

  public fullName() {
    return `${this.nameFirst} ${this.nameLast}`
  }
}

const StudentContactSchema = z.object({
  studentContactId: z.number().gt(0),
  nameFirst: z.string(),
  nameLast: z.string(),
  email: z.string().optional(),
  phoneCell: z.string().optional()
})

export class StudentContact {
  constructor(data: z.infer<typeof StudentContactSchema>) {
    Object.assign(this, data)
  }

  public readonly studentContactId!: number
  public readonly nameFirst!: string
  public readonly nameLast!: string
  public readonly email?: string
  public readonly phoneCell?: string

  public fullName() {
    return `${this.nameFirst} ${this.nameLast}`
  }
}

export const studentSchemas = {
  CourseInfo: CourseInfoSchema,
  Student: StudentSchema,
  StudentContact: StudentContactSchema
}
